import React, { useEffect } from 'react';

const useOutsideClickHandler = (refId: string, onOutsideClick: () => void) => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent): boolean => {
      const specificElement = document.getElementById(refId);
      if (specificElement && specificElement.contains(e.target as Node)) {
        return true;
      }
      onOutsideClick(); //perform actions if click is outside of an element
      return false;
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [refId, onOutsideClick]);
};

export default useOutsideClickHandler;
